// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/credit-card.js';

import { paths } from '../generated/credit-card';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('credit-card', Original, paths);
